module.exports = __webpack_public_path__ + "static/media/bosch-contact.9c92395d.jpg";